import { UploadProgressContext } from "@/contexts/UploadProgressContext";
import { useContext } from "react";

export function UploadToast({ uploadId }: { uploadId: string }) {
	const { toasts } = useContext(UploadProgressContext);

	const progress = toasts[uploadId] || 0;

	return (
		<div className={"flex flex-row items-start gap-3"}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
				className="animate-spin"
			>
				<title>spinner</title>
				<path d="M21 12a9 9 0 1 1-6.219-8.56" />
			</svg>
			<div className={"flex flex-col gap-0"}>
				<div className="font-semibold text-base leading-none">
					Enviando arquivo...
				</div>
				<div className="font-medium text-muted-foreground text-xs">
					{(progress || 0).toLocaleString("pt-BR", {
						style: "percent",
					})}{" "}
					concluído
				</div>
			</div>
		</div>
	);
}
